export const CAL_START_HOUR = 6

/**
 * Fixed height of the sticky day-column header.
 * Must match the spacer in the time-axis column so labels align with gridlines.
 * Breakdown: py-2 (16px) + text-sm dayName (20px) + text-2xl leading-tight dayNum (30px) + text-xs monthName (16px) = 82px
 */
export const CAL_HEADER_HEIGHT = 82
export const CAL_END_HOUR = 22
export const CAL_TOTAL_MINUTES = (CAL_END_HOUR - CAL_START_HOUR) * 60

/** Fixed pixel height per 1 hour slot */
export const HOUR_HEIGHT = 64

/** Total pixel height of the scrollable time grid */
export const CAL_TOTAL_HEIGHT = (CAL_END_HOUR - CAL_START_HOUR) * HOUR_HEIGHT

export const CAL_HOURS = Array.from(
  { length: CAL_END_HOUR - CAL_START_HOUR + 1 },
  (_, i) => CAL_START_HOUR + i,
)

/** Returns top offset in pixels for a given ISO datetime */
export function getTopPx(dateIso: string): number {
  const d = new Date(dateIso)
  const minuteOfDay = d.getHours() * 60 + d.getMinutes()
  const offset = minuteOfDay - CAL_START_HOUR * 60
  return Math.max(0, (offset / 60) * HOUR_HEIGHT)
}

/** Returns height in pixels for a given duration in minutes */
export function getHeightPx(durationMinutes: number): number {
  return Math.max(0, (durationMinutes / 60) * HOUR_HEIGHT)
}

export function formatHour(hour: number): string {
  return `${String(hour).padStart(2, '0')}:00`
}

/** Extract decimal hour (e.g. 8.5 for 08:30) from ISO using local getHours/getMinutes */
export function getHourFromIso(iso: string): number {
  const d = new Date(iso)
  return d.getUTCHours() + d.getUTCMinutes() / 60
}
